import {useEffect, useState} from 'react';
import {ICoordinate, Replacement} from '../interface';
import _ from 'lodash';
import {getGeocode} from '../utils/getGeocode';
import { UNDETECT_LOCATION_PERMISSIONS } from '../constants';
import localesReplacement from "../utils/localesReplacement";

export const usePosition = (
  pos: string | undefined = undefined,
  replacements: Replacement,
): [ICoordinate, (value: ICoordinate) => void] => {
  const [myPosition, setPosition] = useState<ICoordinate>();
  let shortLang;
  
  function showPosition(d: GeolocationPosition) {
    _.isUndefined(myPosition) &&
      setPosition({lat: d.coords.latitude, lng: d.coords.longitude});
  }

  function getLanguageCode()
  {
    shortLang = window.navigator.languages ? navigator.languages[0] : null;
    
    if (shortLang?.indexOf('-') !== -1)
        shortLang = shortLang?.split('-')[0];

    if (shortLang?.indexOf('_') !== -1)
        shortLang = shortLang?.split('_')[0];
      return shortLang;
  }

  function showError() {
    if (pos) {
      if(!sessionStorage.getItem(UNDETECT_LOCATION_PERMISSIONS)) {
        sessionStorage.setItem(UNDETECT_LOCATION_PERMISSIONS, 'true');
        const toLang = getLanguageCode();
        const text = localesReplacement(replacements, 'Please enable location permissions to proceed further with navigation.');
        // ============= Auto translate  =============

        // const fromLang = 'en';
        // let url = `https://translation.googleapis.com/language/translate/v2?key=${process.env.REACT_APP_GOOGLE_KEY}`;
        // url += '&q=' + encodeURI(text);
        // url += `&source=${fromLang}`;
        // url += `&target=${toLang}`;

        // fetch(url, { 
        //   method: 'GET',
        //   headers: {
        //     "Content-Type": "application/json",
        //     Accept: "application/json"
        //   }
        // })
        // .then(res => res.json())
        // .then((response) => {
        //   console.log("response from google: ", response);
        // })
        // .catch(error => {
        //   console.log("There was an error with the translation request: ", error);
        // });
        // ==========================

        alert(localesReplacement(replacements, 'Please enable location permissions to proceed further with navigation'));
      }
      getGeocode(pos).then((d) => setPosition(d.results[0].geometry.location));
    }
  }

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      pos &&
        getGeocode(pos).then((d) =>
          setPosition(d.results[0].geometry.location),
        );
    }
  }, [pos]);
  return [myPosition as ICoordinate, setPosition];
};
